import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import {
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const ItemWiseUsedTotalReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState(moment().format("YYYY-MM"));

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [selectedItemName, setSelectedItemName] = useState("");
  const [selectedItemUnitForPo, setSelectedItemUnitForPo] = useState("");
  const [grandTotalCost, setGrandTotalCost] = useState(0);
  const toggleModal = () => setModalOpen(!modalOpen);

  useEffect(() => {
    if (monthYear) {
      const startOfMonth = moment(monthYear, "YYYY-MM")
        .startOf("month")
        .format("YYYY-MM-DD");
      const endOfMonth = moment(monthYear, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
      // Keeping these for potential use elsewhere if needed, but not for loadOrders
      setDateFrom(startOfMonth);
      setDateTo(endOfMonth);
    }
  }, [monthYear]);

  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async () => {
    try {
      preloader(true);
      setFilteredOrders([]);
      setAllOrders([]);
      let url = process.env.REACT_APP_BASEURL + "reports/branchwise_used_items_summary_new";
      
      const response = await postSubmitForm(url, {
        monthYear: monthYear
      });

      if (response && response.status === 1) {
        let result = response.data?.items || [];
        setAllOrders(result);
        setGrandTotalCost(response.data?.grand_total_cost || 0);
        if (result?.length <= 0) {
          showNotification("No Orders data found", "warning");
        }
      } else {
        showNotification(response?.message || "Error fetching report", "error");
      }
    } catch (error) {
      console.log(error);
      showNotification("Something went wrong", "error");
    } finally {
      preloader(false);
    }
  };

  const loadItemDetails = async (itemId, itemName, unitForPo) => {
    try {
      preloader(true);
      setSelectedItemName(itemName);
      setSelectedItemUnitForPo(unitForPo);
      let url = process.env.REACT_APP_BASEURL + "reports/branchwise_used_items_new_by_item";
      const response = await postSubmitForm(url, {
        monthYear: monthYear,
        item_id: itemId
      });

      if (response && response.status === 1) {
        setModalData(response.data || []);
        setModalOpen(true);
      } else {
        showNotification(response?.message || "Error fetching item details", "error");
      }
    } catch (error) {
      console.log(error);
      showNotification("Something went wrong", "error");
    } finally {
      preloader(false);
    }
  };
  
  const [filteredOrders, setFilteredOrders] = useState([]);
  function afterFilter(newResult, newFilters) {
    setFilteredOrders(prevOrders => {
      return JSON.stringify(prevOrders) !== JSON.stringify(newResult) ? newResult : prevOrders;
    });
  }
  useEffect(() => {
    loadOrders();
  }, []);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      footer: true,
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },


    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      formatter: (cell, row) => (
        <span
          className="text-info mr-2"
          title="View Details"
          style={{ cursor: "pointer" }}
          onClick={() => loadItemDetails(row.item_id, row.name, row.unit_for_po)}
        >
          {cell}
        </span>
      ),
      // filter: selectFilter({
      //   options: () => {
      //     const unique = [
      //       ...new Map(
      //         allOrders.map((item) => [
      //           item.name,
      //           { value: item.name, label: item.name },
      //         ])
      //       ).values(),
      //     ];
      //     unique.sort(dynamicSort("label"));
      //     return unique;
      //   },
      // }),
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders.map((item) => [
                item.category,
                { value: item.category, label: item.category },
              ])
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Total Quantity"),
      dataField: "total_quantity",
      footer: true,
      formatter: (cell, row, rowIndex) => {
        return formatUnitsForReport(row.total_quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      text: props.t("Average Price"),
      dataField: "average_price",
       footer: true,
      formatter: (cell, row) => {
        return Number(row?.average_price || 0).toFixed(2);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Total Cost"),
      dataField: "total_cost",
      sort: true,
      formatter: (cell, row) => {
        return Number(row?.total_cost || 0).toFixed(2);
      },
      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const modalColumns = [
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      text: props.t("#"),
      footer: true,
      headerStyle: { width: "5%" },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_name",
      footer: true,
      sort: true,
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      footer: true,
      sort: true,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      footer: true,
      formatter: (cell, row) => formatUnitsForReport(row.quantity),
    },
    {
      text: props.t("Cost Price"),
      dataField: "cost_price",
      footer: true,
      formatter: (cell) => Number(cell || 0).toFixed(2),
    },
    {
      text: props.t("Total Cost"),
      dataField: "total_cost",
      formatter: (cell) => Number(cell || 0).toFixed(2),
      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),
    },
    {
      text: props.t("Date"),
      footer: true,
      dataField: "createdAt",
      formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm"),
    },
  ];


  const handleDownload = async () => {
    const fileName = "branchwise_item_used_report";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Items: v.name,
          Category: v.category,
          SubCategory: v.sub_category,
          "Total Quantity": ExportAvailableInCSVForReports(v.total_quantity),
          "Average Price": v.average_price,
          "Total Cost": v.total_cost,
        });
      });


      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleModalDownload = async () => {
    const fileName = `branchwise_item_used_details_${selectedItemName}`;
    const exportType = "xls";

    if (modalData) {
      var data = [];
      JSON.parse(JSON.stringify(modalData)).forEach(function (v) {
        data.push({
          Branch: v.branch_name,
          Batch: v.batch,
          Quantity: ExportAvailableInCSVForReports(v.quantity),
          "Cost Price": v.cost_price,
          "Total Cost": v.total_cost,
          Date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Item Wise Used Total Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Item Wise Used Total Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="monthYear"
                          label={props.t("Select Month")}
                          type="month"
                          value={monthYear}
                          onChange={(e) => setMonthYear(e.target.value)}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (monthYear) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>

                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="printDiv">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                      <div className="d-flex align-items-center mb-2 mb-md-0 d-print-none">
                        <Button
                          type="submit"
                          className="btn btn-sm btn-secondary mr-2"
                          onClick={handleDownload}
                        >
                          <i className="mdi mdi-file-export"></i>{" "}
                          {props.t("Export CSV")}
                        </Button>
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("printDiv");
                          }}
                          className="btn btn-sm btn-success"
                        >
                          <i className="fa fa-print"></i> {props.t("Print")}
                        </Link>
                      </div>

                      <CardTitle className="text-center m-0 flex-grow-1 px-3 mb-2 mb-md-0">
                        {props.t("Item Wise Used Total Report")} - {moment(monthYear).format("MMMM YYYY")}
                      </CardTitle>

                      {(filteredOrders.length > 0 || allOrders.length > 0) && (
                        <div className="text-right mb-2 mb-md-0">
                          <h5 className="m-0">
                            {props.t("Grand Total Cost")}:{" "}
                            QR {Number(
                              (filteredOrders.length > 0 ? filteredOrders : allOrders).reduce(
                                (acc, item) => acc + (Number(item.total_cost) || 0),
                                0
                              )
                            ).toFixed(2)}
                          </h5>
                        </div>
                      )}
                    </div>

                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                           <BootstrapTable
                            striped
                            hover
                            condensed
                            sort={true}
                            classes="table-sm"
                            filter={filterFactory({ afterFilter })}
                            {...props.baseProps}
                          />

                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal}>
          <div className="d-flex justify-content-end align-items-center w-100">
            <div className="ml-auto">
              <Button
                color="secondary"
                className="btn-sm mr-2"
                onClick={handleModalDownload}
              >
                <i className="mdi mdi-file-export"></i> {props.t("Export CSV")}
              </Button>
              <Button
                color="success"
                className="btn-sm"
                onClick={() => printDiv("modalPrintDiv")}
              >
                <i className="fa fa-print"></i> {props.t("Print")}
              </Button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div id="modalPrintDiv">
            <div className="mb-3 text-center">
              <h4>{selectedItemName}</h4>
            </div>
            <Row className="mb-3">
              <Col md={8}>
                {modalData[0]?.item_details?.unit_levels && (
                  <div className="mb-2">
                    <strong>{props.t("Formula")}: </strong>
                    {modalData[0].item_details.unit_levels
                      .sort((a, b) => a.value - b.value)
                      .map((ul, index, arr) => (
                        <span key={index}>
                          {ul.value} {ul.unit}
                          {index < arr.length - 1 ? " = " : ""}
                        </span>
                      ))}
                    <span className="ml-3">
                      <strong>{props.t("Purchasing Unit")}: </strong>
                      {selectedItemUnitForPo || "N/A"}
                    </span>
                  </div>
                )}
              </Col>
              <Col md={4} className="text-right">
                <h5 className="m-0 text-primary">
                  {props.t("Grand Total Cost")}: QR{" "}
                  {modalData
                    .reduce((acc, item) => acc + (Number(item.total_cost) || 0), 0)
                    .toFixed(2)}
                </h5>
              </Col>
            </Row>
            <ToolkitProvider
              keyField="_id"
              data={modalData}
              columns={modalColumns}
              search
            >
              {(props) => (
                <div>
                  <Row className="mb-2 no-print">
                    <Col md="4">
                      <SearchBar {...props.searchProps} />
                    </Col>
                  </Row>
                  <BootstrapTable
                    {...props.baseProps}
                    striped
                    hover
                    condensed
                    classes="table-sm"
                    noDataIndication={() => props.t("No details found")}
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {}
  )(withNamespaces()(ItemWiseUsedTotalReport))
);
